import { type ScanDetectorConfig } from '../types/scanDetector.type';

export const SCAN_DETECTION_DEFAULTS: ScanDetectorConfig = {
  bufferTimeoutMs: 150,
  duplicateWindowMs: 400,
  interKeySlackCount: 0,
  maxAvgTimeMs: 25,
  maxDurationMs: 700,
  maxInterKeyMs: 60,
  minLength: 3,
  suffixDetection: ['Enter', 'Tab'],
};
